import { memo } from 'react';
import { AlertBanner } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';

/**
 * Red banners at the top of the match step: one per missing required field. While any shows,
 * Next is disabled.
 *
 * @param {object} props
 * @param {Array<'email_missing'|'name_missing'>} props.errors From `selectMappingErrors`.
 */
function MappingRequiredBanner({ errors }) {
  const { t } = useTranslation('people-access');
  if (errors.length === 0) return null;

  return (
    <div className="flex flex-col gap-2">
      {errors.map((error) => (
        <AlertBanner key={error} tone="danger" title={t(`import.match.errors.${error}.title`)}>
          {t(`import.match.errors.${error}.message`)}
        </AlertBanner>
      ))}
    </div>
  );
}

export default memo(MappingRequiredBanner);
